export const culture_festivals = [
  { char: '🧧', name: 'Red Envelope', nameZh: '農曆新年', keywords: ['cny', 'money', 'luck'], hot: true },
  { char: '🏮', name: 'Lantern', nameZh: '元宵節/燈會', keywords: ['festival', 'light', 'asia'] },
  { char: '🎑', name: 'Moon Viewing', nameZh: '中秋節', keywords: ['moon', 'festival', 'autumn'] },
  { char: '🎄', name: 'Christmas Tree', nameZh: '聖誕節', keywords: ['xmas', 'winter', 'gift'], hot: true },
  { char: '🎃', name: 'Pumpkin', nameZh: '萬聖節', keywords: ['halloween', 'scary', 'spooky'] },
  { char: '🎆', name: 'Fireworks', nameZh: '跨年/慶典', keywords: ['new year', 'party', 'firework'] },
  { char: '🕌', name: 'Mosque', nameZh: '宗教建築', keywords: ['islam', 'religion', 'pray'] },
  { char: '🛕', name: 'Hindu Temple', nameZh: '文化地標', keywords: ['temple', 'india', 'place'] },
  { char: '⛩️', name: 'Shrine', nameZh: '神社/參拜', keywords: ['japan', 'shrine', 'culture'] },
  { char: '🕍', name: 'Synagogue', nameZh: '經典遺址', keywords: ['history', 'religion', 'jewish'] },
  { char: '🎏', name: 'Carp Streamer', nameZh: '民俗活動', keywords: ['japan', 'tradition', 'child'] },
  { char: '🎋', name: 'Tanabata', nameZh: '祈願許願', keywords: ['wish', 'star', 'japan'] },
];